import { removeNodeAtPath, changeNodeAtPath } from 'react-sortable-tree'
import { getNodeKey } from 'actions/manual_pages/admin_actions'
import { findNodeByPath } from './search'

export const completePathForAction = (path, id) => [null].concat(path, id)

export const callWithCompletedPagePath = (page, stateUpdateFunc) => {
  page.path = completePathForAction(page.path, page.id)
  return stateUpdateFunc(page)
}

export const deleteNodeFromTree = (state, action) => {
  const path = completePathForAction(action.data.path, action.id)
  const changedTreeData = removeNodeAtPath({ treeData: state.treeData, path, getNodeKey })
  state.treeData = changedTreeData
}

export const updateNodeInTree = (state, page) => {
  const changedTreeData = changeNodeAtPath({ treeData: state.treeData, path: page.path, newNode: page, getNodeKey })
  state.treeData = changedTreeData
}

export const addNodeToTree = (state, page) => {
  if (!state.treeData) state.treeData = []
  
  const parentPath = page.path ? [null].concat(page.path) : [null]
  const parentNode = findNodeByPath(state.treeData, parentPath)
  
  if (parentNode) {
    if (!parentNode.children) parentNode.children = []
    parentNode.children.push(page)
  }
}

export const selectPageForEdit = (state, page) => {
  state.page = page
}

export const resetFormData = (state) => {
  state.page = {}
}
